import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Typography } from '@mui/material'

interface ListingTruncationNoteProps {
  shown: number
  total: number | undefined
}

/**
 * Caption under a paged listing that tells the user they are looking at the
 * first page only. Renders nothing while the whole result set fits.
 */
export const ListingTruncationNote: FC<ListingTruncationNoteProps> = ({ shown, total }) => {
  const { t } = useTranslation('ua-insights')
  if (total === undefined || shown >= total) return null
  return (
    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', px: 2, py: 1 }}>
      {t('listing_showing_first_of_total', { shown, total })}
    </Typography>
  )
}
